import axios from 'axios';
import * as actions from './actionsTypes';
import messages from '../../../messages';
import DashboardSelecContratacionesServices from './dashboardSelecContrataciones.services';

export const getDashboardSelecRespContrataciones = (filters) => async dispatch => {
  try {
    dispatch({
      type: actions.LOADING_DASHBOARD_SELECT_RESPONSIBLE_CONTRATACIONES,
      payload: true
    });

    const resp = await DashboardSelecContratacionesServices.getDashboarSelecContrataciones(filters);
    const oData = resp.data;

    //console.log("estos son los datos PASTEl:", oData
   // oData.datasets[0].backgroundColor = '';
   // oData.datasets[0].hoverBackgorundColor = '';
   // oData.datasets[1].backgroundColor = '#e48100';
    //oData.datasets[1].hoverBackgorundColor = '#e48100';
    //oData.datasets[2].backgroundColor = 'grey';
    //oData.datasets[2].hoverBackgorundColor = 'grey';

    dispatch({
      type: actions.GET_DASHBOARD_SELECT_RESPONSIBLE_CONTRATACIONES,
      payload: oData
    });

  } catch (ex) {
    let message = '';
    if (axios.isAxiosError(ex)){
      if(ex.response?.data){
        message = ex.response.data.message;
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.DASHBOARD_SELECT_ERROR_CONTRATACIONES,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADING_DASHBOARD_SELECT_RESPONSIBLE_CONTRATACIONES,
      payload: false
    });
  }
}